import axios from 'axios/index';
import qs from 'qs';

function setAuth(token) {
    sessionStorage.setItem("_ct_", token);
    axios.defaults.headers.common['Authorization'] = token;
}

function clearAuth() {
    sessionStorage.removeItem("_ct_");
    delete axios.defaults.headers.common['Authorization'];
}

function isAuth() {
    return sessionStorage.getItem('_ct_') != null;
}

function fixSearch(search) {
    if (!search) {
        search = {};
    }
    if (!search.pageNumber) {
        search.pageNumber = 0;
    }

    if (search.sortOrder && ['ASC','DESC'].indexOf(search.sortOrder) == -1) {
        search.sortOrder = 'ASC';
    }

    return search;
}

function handleErrorResponse(error) {
    // if there's a network/connection issue, then all we have to go off of
    // from axios is that it gives us a message of 'Network Error'
    if (error && error.message && error.message === 'Network Error') {
        return {
            is_network_error : true
        }
    }
    if (error && error.response && error.response.data) {
        const response = error.response.data;
        if (response.notAuthenticated) {
            clearAuth();
            window.location.href  = "/";
        } else if (response.is_error) {
            return response;
        } else if (response.violations) {
            return {violations:response.violations};
        } else {
            return {
                is_error:true,
                message:"An unknown Error has Occurred",
                data:response
            };

        }
    } else {
        return {
            is_error:true,
            message:"An unknown Error has Occurred"
        };
    }

}

function standardGet(uri) {
    return function(identifier) {
        return new Promise((resolve,reject) => {
            axios.get('api/'+uri+'/'+identifier).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    }
}

function standardPost(uri) {
    return function(obj) {
        return new Promise((resolve, reject) => {
            axios.post('api/'+uri, obj).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    }
}

function standardPatch(uri,idProperty) {
    return function(obj) {
        return new Promise((resolve, reject) => {
            axios.patch('api/'+uri+'/'+obj[idProperty],obj).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    }
}

function standardDelete(uri) {
    return function(id) {
        return new Promise((resolve, reject) => {
            axios.delete('api/'+uri+'/'+id).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    }
}


const ApiAuth = {
    get : function(username,password) {
        return new Promise((resolve,reject) => {
            axios.get("api/auth",{
                auth:{
                    username:username,
                    password:password
                }
            })
                .then(response => {
                    resolve(response.data);
                },(error) => {
                    reject(error);
                }).catch(error => {
                    reject(error);
            });
        });
    }
}

const ApiFirstAlert = {
    organizationConfig : function(organizationId) {
        return new Promise((resolve,reject) => {
            axios.get('api/config/organization/'+organizationId)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    validate : function(organizationId) {
        return new Promise((resolve,reject) => {
            axios.get('api/config/validator/'+organizationId)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    announcement : {
        post : function(premiseId,announcement) {
            return new Promise((resolve,reject) => {
                axios.post(`api/announcement`,announcement)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    }
}



const ApiUserProfile = {
    get: function() {
        return new Promise((resolve,reject) => {
            axios.get('api/user-profile').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    patch: function(obj) {
        return new Promise((resolve,reject) => {
            axios.patch('api/user-profile',obj).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    password : {
        post : function(userId,password) {
            return new Promise((resolve,reject) => {
                axios.post(`api/user/${userId}/password`, password, {headers: { 'Content-Type': 'text/plain' }}).then((response) => {
                    resolve(response.data)
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    organization : {
        primary : {
            get : function() {
                return new Promise((resolve,reject) => {
                    axios.get('api/user-profile/organization/primary').then(response => {
                        resolve(response.data);
                    }).catch(error => {
                        reject(handleErrorResponse(error));
                    });
                });
            }
        }
    }
}

const ApiCadConfig = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/cad', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.rowsPerPage,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    patch : standardPatch("cad","id"),
    get   : standardGet("cad"),
    post  : standardPost("cad")
}

const ApiPremise = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/premise', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.pageSize,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder,
                    name : searchObj.name,
                    subName : searchObj.subName,
                    address : searchObj.address,
                    organizationId : searchObj.organizationId
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get : standardGet('premise'),
    post : standardPost('premise'),
    patch : standardPatch('premise','id'),
    delete : standardDelete('premise'),
    contactList : {
        get : function(premiseId) {
            return new Promise((resolve,reject) => {
                axios.get(`api/premise/${premiseId}/contact-list`)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    point : {
        get : function(premiseId) {
            return new Promise((resolve,reject) => {
                axios.get('api/premise/'+premiseId+'/point')
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                        reject(handleErrorResponse(error));
                    });
            });
        },
        post : function(premiseId,point) {
            return new Promise((resolve,reject) => {
                axios.post("api/premise/"+premiseId+"/point",point)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                        reject(handleErrorResponse(error));
                    });
            });
        },
        patch : function(premiseId,point) {
            return new Promise((resolve,reject) => {
                axios.patch("api/premise/"+premiseId+"/point/"+point.id,point)
                    .then(response => {
                        resolve(response.data);
                    }) .catch(error => {
                        reject(handleErrorResponse(error));
                });
            });
        },
        del : function(premiseId,pointId) {
            return new Promise((resolve,reject) => {
                axios.delete("api/premise/"+premiseId+"/point/"+pointId)
                    .then(response => {
                        resolve(response.data);
                    }) .catch(error => {
                        reject(handleErrorResponse(error));
                });
            });
        },
        deleteAll : function(premiseId) {
            return new Promise((resolve,reject) => {
                axios.delete("api/premise/"+premiseId+"/point")
                    .then(response => {
                        resolve(response.data);
                    }) .catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    setting : {
        get(premiseId,key) {
            return new Promise((resolve,reject) => {
                axios.get(`api/premise/${premiseId}/setting/${key}`)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    }
};

const ApiButton = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/button', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.pageSize,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder,
                    label : searchObj.label,
                    profileId : searchObj.profileId
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    buttonIndexes : {
        get: function (buttonId) {
            return new Promise((resolve, reject) => {
                axios.get(`api/button/${buttonId}/button-indexes/`)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    get : standardGet('button'),
    post : standardPost('button'),
    patch : standardPatch('button','id'),
    delete : standardDelete('button'),
    eventTypes : {
        get : function(buttonId) {
            return new Promise((resolve,reject) => {
                axios.get('api/button/event-types/'+buttonId)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
    },
    contactList : {
        get : function(buttonId) {
            return new Promise((resolve,reject) => {
                axios.get(`api/button/${buttonId}/contact-list`)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        post : function(buttonId,contactListId) {
            return new Promise((resolve,reject) => {
                axios.post(`api/button/${buttonId}/contact-list/${contactListId}`)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        delete : function(buttonId,contactListId) {
            return new Promise((resolve,reject) => {
                axios.post(`api/button/${buttonId}/contact-list/${contactListId}`)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    }
};

const ApiOrganization = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/organization', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.rowsPerPage,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder,
                    name : searchObj.name
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get : standardGet('organization'),
    post : standardPost('organization'),
    patch : standardPatch('organization','id'),
    cad : {
        post : function(orgId,configId) {
            return new Promise((resolve,reject) => {
                axios.post('api/organization/'+orgId+'/cad/'+configId)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        delete : function(orgId,configId) {
            return new Promise((resolve,reject) => {
                axios.delete('api/organization/'+orgId+'/cad/'+configId)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    application : {
        get : function(orgId) {
            return new Promise((resolve,reject) => {
                axios.get('api/organization/'+orgId+'/application')
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                        reject(handleErrorResponse(error));
                    });
            });
        },
        post : function(orgId,appIds) {
            return new Promise((resolve,reject) => {
                axios.post('api/organization/'+orgId+'/application',appIds)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                        reject(handleErrorResponse(error));
                    });
            });
        }
    },
    incidents : {
        getActive : function(orgId) {
            return new Promise((resolve,reject) => {
                axios.get('api/organization/'+orgId+'/active-incident')
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
    },
	spreadsheet : {
		post : function(organizationId,file,suppressNotifications) {
            suppressNotifications = suppressNotifications || false;
			return new Promise((resolve,reject) => {
				let data = new FormData();
				data.append('file', file, file.fileName);
                data.append('suppressNotifications', suppressNotifications);
				axios.post(`api/organization/${organizationId}/spreadsheet`, data, {
					headers: {
						'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
					}
				}).then((response) => {
					resolve(response.data);
				}).catch((error) => {
					if (error && error.response && error.response.data) {
						if (error.response.data.spreadsheetError) {
							reject(error.response.data);
						} else {
							reject(handleErrorResponse(error));
						}
					}

				});
			});
		}
	},
    newUserNotifications : function(organizationId, parameters) {
        return new Promise((resolve,reject) => {
            axios.post(`api/organization/${organizationId}/new-user-notifications`,parameters)
                .then(response => {
                    resolve(response.data);
                }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    }
};

const ApiUser = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/user', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.rowsPerPage,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder,
                    organizationIds : searchObj.organizationIds,
                    firstName : searchObj.firstName,
                    lastName : searchObj.lastName,
                    status : searchObj.status,
                    email : searchObj.email
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get : standardGet('user'),
    patch : standardPatch('user','id'),
    post : standardPost('user'),
    delete : standardDelete('user'),
    updateStatus: (userId,status) => {
        return new Promise((resolve,reject) => {
            axios.put('api/user/' + userId + '/status/'+status).then(response => {
                resolve();
            }).catch(error => reject(handleErrorResponse(error)));
        });
    },
    // TODO deprecate and replace with ApiUserOrganization search
    // THIS IS NOW DEPRECATED AND SHOULD BE REMOVED
    organization : {
        get : function(userId) {
            return new Promise((resolve, reject) => {
                axios.get('api/user/'+userId+'/organization').then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    profile : {
        get : function(userId) {
            return new Promise((resolve, reject) => {
                axios.get('api/user/'+userId+'/profile').then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    role : {
        get : function(userId) {
            return new Promise((resolve, reject) => {
                axios.get('api/user/'+userId+'/role').then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        post : function(userId,roleIds) {
            return new Promise((resolve, reject) => {
                axios.post('api/user/'+userId+'/role',roleIds).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    status: {
        post : function(userId,statusCode) {
            return new Promise((resolve,reject) => {
                axios.post('api/user/' + userId + '/status/'+statusCode).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    password : {
        post : function(userId,password) {
            return new Promise((resolve,reject) => {
                axios.post('api/user/' + userId + '/password',password,{headers: { 'Content-Type': 'text/plain' }}).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        email : {
            post : function(userId) {
                return new Promise((resolve,reject) => {
                    axios.post(`api/user/${userId}/password/email`).then(response => {
                        resolve(response.data);
                    }).catch(error => {
                        reject(handleErrorResponse(error));
                    });
                });
            }
        }
    },
    token : {
        delete : function(userId) {
            return new Promise((resolve,reject) => {
                axios.delete('api/user/'+userId+'/token').then((response) => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                })
            });
        }
    },
    selfPassword : {
        post : function(password) {
            return new Promise((resolve,reject) => {
                axios.post('api/user/password',password,{headers: { 'Content-Type': 'text/plain' }}).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
}

const ApiUserOrganization = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/user-organization', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.rowsPerPage,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder,
                    primary : searchObj.primary,
                    admin : searchObj.admin,
                    userId : searchObj.userId,
                    organizationId : searchObj.organizationId
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get : function(userId) {
        return new Promise((resolve, reject) => {
            axios.get(`api/user-organization/${userId}`).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    post : standardPost('user-organization'),
    delete : function(userId,organizationId) {
        return new Promise((resolve,reject) => {
            axios.delete('api/user-organization/'+userId+'/'+organizationId).then((response) => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            })
        });
    }
}

const ApiApplication = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {``
            axios.get('api/application', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.pageSize,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
}

const ApiProfile = {

    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {``
            axios.get('api/profile', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.pageSize,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder,
                    name : searchObj.name,
                    premiseId : searchObj.premiseId,
                    userId : searchObj.userId
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get : standardGet('profile'),
    post : standardPost('profile'),
    patch : standardPatch('profile','id'),
    delete : standardDelete('profile'),
    eventTypes : {
        get: function (profileId) {
            return new Promise((resolve, reject) => {
                axios.get('api/profile/event-types/' + profileId)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    user : {
        post: function(profileId,userId) {
            return new Promise((resolve, reject) => {
                axios.post('api/profile/'+profileId+'/user/'+userId).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        del: function(profileId,userId) {
            return new Promise((resolve, reject) => {
                axios.delete('api/profile/'+profileId+'/user/'+userId).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    buttonIndexes : {
        get: function (profileId) {
            return new Promise((resolve, reject) => {
                axios.get(`api/profile/${profileId}/button-indexes/`)
                    .then(response => {
                        resolve(response.data);
                    }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    copyToOtherPremise : function(profileId,targetPremiseId) {
        return new Promise((resolve, reject) => {
            axios.post('api/profile/'+profileId+'/premise/'+targetPremiseId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    }
};

const ApiContact = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/contact', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.pageSize,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder,
                    name : searchObj.name,
                    phoneNumber : searchObj.phoneNumber,
                    organizationId : searchObj.organizationId
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get : standardGet('contact'),
    post : standardPost('contact'),
    patch : standardPatch('contact','id'),
    //delete : standardDelete('contact'),
    contactList : {
        get : function(id) {
            return new Promise((resolve, reject) => {
                axios.get(`api/contact/${id}/contact-list`).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    }
};

const ApiContactList = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/contact-list', {
                params : {
                    pageNumber: searchObj.pageNumber,
                    pageSize: searchObj.pageSize,
                    sortBy : searchObj.sortBy,
                    sortOrder : searchObj.sortOrder,
                    name : searchObj.name,
                    organizationId : searchObj.organizationId,
                    contactName : searchObj.contactName,
                    phoneNumber : searchObj.phoneNumber
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get : standardGet('contact-list'),
    post : standardPost('contact-list'),
    patch : standardPatch('contact-list','id'),
    //delete : standardDelete('contact'),
    contact: {
        get : function(id) {
            return new Promise((resolve, reject) => {
                axios.get(`api/contact-list/${id}/contact`).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        post : function(id,contactId) {
            return new Promise((resolve, reject) => {
                axios.post(`api/contact-list/${id}/contact/${contactId}`).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        delete : function(id,contactId) {
            return new Promise((resolve, reject) => {
                axios.delete(`api/contact-list/${id}/contact/${contactId}`).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    }
};

const ApiPermission = {
    search: function () {
        return new Promise((resolve, reject) => {
            axios.get('api/permission').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get: standardGet('permission')
};

const ApiIncident = {
    search : function(searchObj) {
        searchObj = fixSearch(searchObj);
        return new Promise((resolve,reject) => {
            axios.get('api/incident', {
                params : {
                    organizationId : searchObj.organizationId,
                    premiseId      : searchObj.premiseId,
                    pageNumber     : searchObj.pageNumber,
                    pageSize       : searchObj.rowsPerPage,
                    sortBy         : searchObj.sortBy,
                    sortOrder      : searchObj.sortOrder
                },
                paramsSerializer: function(params) {
                    return qs.stringify(params, {arrayFormat: 'repeat'})
                }
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    get : standardGet('incident'),
    updateStatus : function(id,statusObject) {
        return new Promise((resolve, reject) => {
            axios.post(`api/incident/${id}/status`,statusObject).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    getStatus : function(id,statusObject) {
        return new Promise((resolve, reject) => {
            axios.get(`api/incident/${id}/status`,statusObject).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(handleErrorResponse(error));
            });
        });
    },
    message : {
        get : function(id) {
            return new Promise((resolve, reject) => {
                axios.get(`api/incident/${id}/message`).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
        post : function(id,message) {
            return new Promise((resolve, reject) => {
                axios.post(`api/incident/${id}/message`,message).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
    },
    communications : {
        get : function(id) {
            return new Promise((resolve, reject) => {
                axios.get(`api/incident/${id}/communications/context`).then(response => {
                    resolve(response.data);
                }).catch(error => {
                    reject(handleErrorResponse(error));
                });
            });
        },
    }
};

export default {
    userProfile : ApiUserProfile,
    firstAlert : ApiFirstAlert,
    helpers: {
        testCadConnection(config) {
            return new Promise((resolve,reject) => {
                axios.post('api/cad/test', config).then((response) => {
                    resolve(response.data);
                }).catch((error) => {
                    reject(handleErrorResponse(error));
                });
            });
        }
    },
    permission: ApiPermission,
    user : ApiUser,
    cadConfig : ApiCadConfig,
    organization : ApiOrganization,
    premise : ApiPremise,
    profile : ApiProfile,
    button : ApiButton,
    application : ApiApplication,
    userOrganization : ApiUserOrganization,
    auth: ApiAuth,
    contact : ApiContact,
    contactList : ApiContactList,
    incident : ApiIncident,
    constants: {
        BUTTON_TYPES : [
            {'code':'police','description':'Police'},
            {'code':'fire','description':'Fire'},
            {'code':'medical','description':'Medical'},
            {'code':'alert','description':'SOS'},
            {'code':'announcement','description':'Announcement'},
        ],
        PUBLICAM_TOKEN : 'PUBLICAM_TOKEN'
    },
    setAuth : setAuth,
    clearAuth : clearAuth,
    isAuth : isAuth
}